import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { t } from "@/lib/i18n";

/**
 * mode: "auto" | "en" | "ht"
 * uiLang: "en" | "ht"  — which language to render labels in
 */
export default function LanguageToggle({ mode, onChange, uiLang }) {
  return (
    <div className="flex items-center gap-2">
      <span className="font-label text-[10px] text-[#6B7280]" data-testid="language-toggle-label">
        {t(uiLang, "forceLang")}
      </span>
      <Tabs value={mode} onValueChange={onChange}>
        <TabsList className="h-8 bg-[#F2ECDF]">
          <TabsTrigger
            value="auto"
            className="text-xs px-3 h-6 data-[state=active]:bg-[#1E3B2F] data-[state=active]:text-white"
            data-testid="language-toggle-auto"
          >
            {t(uiLang, "auto")}
          </TabsTrigger>
          <TabsTrigger
            value="en"
            className="text-xs px-3 h-6 data-[state=active]:bg-[#1E3B2F] data-[state=active]:text-white"
            data-testid="language-toggle-en"
          >
            EN
          </TabsTrigger>
          <TabsTrigger
            value="ht"
            className="text-xs px-3 h-6 data-[state=active]:bg-[#C25934] data-[state=active]:text-white"
            data-testid="language-toggle-kr"
          >
            KR
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
